// Import Bootstrap javascript
import 'bootstrap';
// import 'bootstrap/js/dist/util'
// import 'bootstrap/js/dist/dropdown'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/collapse'
// import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/modal'

// import 'jquery'

// Import custom styles
import '../scss/hosting.scss';

import './offcanvas.js';

import './sendform';

// Enabling HMR
if (module.hot) {
    module.hot.accept(console.log('Aceptando nuevos cambios...'));
}

$(document).ready(function() {
    $('#plan_especial').change(function() {
        if (this.checked) {
            $('#especial_req').removeClass('d-none');
        }
    });
});
